import { TextField, Typography } from '@material-ui/core';
import { FC } from 'react';
import YoutubeIframe from '../../VideoYoutubeEmbed';
import {
  VideoModalActions,
  VideoModalCheckboxes,
  VideoModalCheckboxState,
  VideoModalHeader,
} from './VideoModalShared';
import useStyles from './style';

type VideoImportYoutubeModalProps = VideoModalCheckboxState & {
  onClose: () => void;
  onBack: () => void;
  url: string;
  onUrlChange: (url: string) => void;
  youtubeInputId: string;
  showYoutubePreview: boolean;
  validateYoutubeUrl: (url: string) => boolean;
  submitError: string;
  onValidate: () => void;
};

const VideoImportYoutubeModal: FC<VideoImportYoutubeModalProps> = ({
  onClose,
  onBack,
  url,
  onUrlChange,
  youtubeInputId,
  showYoutubePreview,
  validateYoutubeUrl,
  submitError,
  onValidate,
  ...checkboxState
}) => {
  const classes = useStyles();
  return (
    <>
      <VideoModalHeader title="Ajouter une vidéo Youtube" onClose={onClose} />
      <div className={classes.videoModalForm}>
        <div>
          <Typography className={classes.videoModalFieldLabel}>URL de la vidéo YouTube</Typography>
          <TextField
            id={youtubeInputId}
            variant="outlined"
            className={classes.videoModalInput}
            name="video"
            value={url}
            onChange={e => onUrlChange(e.target.value)}
            placeholder="https://www.youtube.com/watch?v=..."
            fullWidth={true}
          />
        </div>
        {showYoutubePreview && url && validateYoutubeUrl(url) && (
          <div className={classes.youtubePreviewBox}>
            <Typography className={classes.youtubePreviewTitle}>Aperçu de la vidéo</Typography>
            <div className={classes.youtubePreviewPlayer}>
              <YoutubeIframe url={url} autoPlay={0} mute={1} />
            </div>
          </div>
        )}
        {submitError && (
          <Typography className={classes.videoUploadError}>{submitError}</Typography>
        )}
        <VideoModalCheckboxes {...checkboxState} />
      </div>
      <VideoModalActions
        validateDisabled={!url || !validateYoutubeUrl(url)}
        onValidate={onValidate}
        onBack={onBack}
      />
    </>
  );
};

export default VideoImportYoutubeModal;
